import { intensiveCareExceptionalCircumstancesDefaultToFalse } from '../ExceptionalCircumstances/intensiveCareExceptionalCircumstances';
import { ActCode } from './ActCode';
import { RequiredDetails } from '../requiredDetail.type';

export default class ActCode15954 implements ActCode {
  // eslint-disable-next-line no-unused-vars
  constructor(private act: any) {}

  getRequiredDetails(): RequiredDetails {
    return [intensiveCareExceptionalCircumstancesDefaultToFalse];
  }
}
